

// import React from 'react';
// import { motion } from 'framer-motion';

// const WealthGraphic = () => {
//   const growthData = [15, 22, 28, 35, 42, 48, 55, 62, 70, 78, 85, 92];
//   const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5, delay: 0.2 }}
//       className="bg-white rounded-xl shadow-md p-5"
//     >
//       <div className="mb-4">
//         <p className="text-gray-400 text-xs uppercase tracking-wide">Portfolio Value</p>
//         <p className="text-2xl font-bold text-primary">$35,000</p>
//       </div>

//       {/* Simple Line Graph Instead of Bars */}
//       <div className="relative h-32 mb-4">
//         <svg className="w-full h-full" viewBox="0 0 400 120" preserveAspectRatio="none">
//           {/* Line */}
//           <motion.polyline
//             initial={{ pathLength: 0, opacity: 0 }}
//             animate={{ pathLength: 1, opacity: 1 }}
//             transition={{ duration: 1, ease: "easeInOut" }}
//             points="0,100 33,90 66,80 100,70 133,60 166,50 200,42 233,35 266,28 300,22 333,15 366,10"
//             fill="none"
//             stroke="#3b82f6"
//             strokeWidth="2"
//             strokeDasharray="400"
//             strokeDashoffset="0"
//             className="line-chart"
//           />
//           {/* Area under line */}
//           <motion.polygon
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 0.1 }}
//             transition={{ duration: 0.8 }}
//             points="0,100 33,90 66,80 100,70 133,60 166,50 200,42 233,35 266,28 300,22 333,15 366,10 366,120 0,120"
//             fill="#3b82f6"
//           />
//         </svg>

//         {/* X-axis labels */}
//         <div className="flex justify-between text-xs text-gray-400 mt-2">
//           {months.filter((_, i) => i % 3 === 0).map((month, idx) => (
//             <span key={idx}>{month}</span>
//           ))}
//         </div>
//       </div>

//       <div className="flex justify-between items-center pt-3 border-t border-gray-100">
//         <div>
//           <p className="text-gray-400 text-xs">Invested</p>
//           <p className="text-primary font-semibold text-sm">$25,000</p>
//         </div>
//         <div>
//           <p className="text-gray-400 text-xs">Returns</p>
//           <p className="text-green-500 font-semibold text-sm">+$10,000</p>
//         </div>
//         <div className="bg-green-50 px-3 py-1 rounded-full">
//           <span className="text-green-500 text-xs font-medium">↑ +40%</span>
//         </div>
//       </div>
//     </motion.div>
//   );
// };

// export default WealthGraphic;

import React from 'react';
import { motion } from 'framer-motion';
import {
  FaArrowUp,
  FaChartLine,
  FaUsers,
} from 'react-icons/fa';

const WealthGraphic = () => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="relative flex items-center justify-center min-h-[520px]"
    >
      {/* BACKGROUND SHAPES */}
      <div className="absolute top-10 left-10 w-72 h-56 bg-[#dff5eb] rounded-[40px] opacity-70"></div>

      <div className="absolute bottom-10 right-10 w-64 h-48 bg-[#edf3ff] rounded-[35px] opacity-80"></div>

      {/* TOP RIGHT CONSULTATION CARD */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="absolute -top-4 -right-4 md:-top-6 md:-right-8 bg-white rounded-[24px] shadow-xl p-5 w-[230px] z-20"
      >
        <div className="flex items-start justify-between">
          <div>
            <h4 className="text-[#2b57b5] font-bold text-lg leading-7">
              Comprehensive
              <br />
              Wealth
              <br />
              Consultation
            </h4>

            <p className="text-gray-500 text-xs mt-2 leading-5">
              Personalized financial planning
            </p>
          </div>

          <div className="w-10 h-10 rounded-xl bg-[#67bf73] flex items-center justify-center text-white shadow-md">
            <FaArrowUp size={14} />
          </div>
        </div>
      </motion.div>

      {/* MAIN GRAPH CARD */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
        className="relative z-10 bg-[#e6f7ea] rounded-[35px] shadow-2xl p-6 w-full max-w-[470px]"
      >
        {/* TITLE */}
        <div className="mb-5 pr-12 md:pr-32">
          <p className="text-[#7ab487] text-sm font-semibold mb-1">
            Build Wealth with Confidence.
          </p>

          <h2 className="text-[42px] leading-[52px] font-extrabold text-[#2b57b5]">
            Grow Saving
            <br />
            Faster
          </h2>
        </div>

        {/* CHART BOX */}
        <div className="bg-[#f8fff9] rounded-[28px] p-5 shadow-inner">
          <div className="relative h-[230px]">
            {/* GRID */}
            <div className="absolute inset-0 grid grid-cols-8 grid-rows-5 opacity-40">
              {Array.from({ length: 40 }).map((_, i) => (
                <div
                  key={i}
                  className="border border-[#dcefe1]"
                ></div>
              ))}
            </div>

            {/* SVG GRAPH */}
            <svg
              viewBox="0 0 400 200"
              className="absolute inset-0 w-full h-full"
              fill="none"
            >
              {/* GREEN LINE */}
              <motion.path
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 2 }}
                d="M0 150 
                   C40 120, 60 60, 100 80 
                   S170 180, 220 120 
                   S300 80, 340 120 
                   S380 150, 400 100"
                stroke="#8dd7a3"
                strokeWidth="4"
                strokeLinecap="round"
              />

              {/* BLUE LINE */}
              <motion.path
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 2, delay: 0.2 }}
                d="M0 160 
                   C60 180, 80 30, 140 70 
                   S210 160, 260 110 
                   S330 140, 400 90"
                stroke="#2b57b5"
                strokeWidth="4"
                strokeLinecap="round"
              />

              {/* BLUE GLOW */}
              <motion.path
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 2, delay: 0.3 }}
                d="M0 160 
                   C60 180, 80 30, 140 70 
                   S210 160, 260 110 
                   S330 140, 400 90"
                stroke="#71d1ff"
                strokeWidth="8"
                strokeOpacity="0.25"
                strokeLinecap="round"
              />

              {/* POINT */}
              <circle
                cx="295"
                cy="103"
                r="10"
                fill="#8dd7a3"
              />

              <circle
                cx="295"
                cy="103"
                r="18"
                fill="#8dd7a3"
                opacity="0.2"
              />
            </svg>
          </div>

          {/* MONTHS */}
          <div className="flex justify-between text-[10px] text-gray-400 mt-4 px-1">
            {[
              'JAN',
              'FEB',
              'MAR',
              'APR',
              'MAY',
              'JUN',
              'JUL',
              'AUG',
            ].map((m, i) => (
              <span key={i}>{m}</span>
            ))}
          </div>
        </div>
      </motion.div>

      {/* CLIENT CARD */}
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.7 }}
        className="absolute bottom-0 left-0 bg-white rounded-2xl shadow-xl px-5 py-4 flex items-center gap-4 z-20"
      >
        <div className="flex -space-x-3">
          <div className="w-10 h-10 rounded-full bg-[#2b57b5] border-2 border-white"></div>

          <div className="w-10 h-10 rounded-full bg-[#67bf73] border-2 border-white"></div>

          <div className="w-10 h-10 rounded-full bg-[#c4d8ff] border-2 border-white"></div>
        </div>

        <div>
          <div className="flex items-center gap-2">
            <FaUsers className="text-[#2b57b5]" />

            <span className="font-bold text-[#222]">
              500+
            </span>
          </div>

          <p className="text-gray-500 text-xs">
            Active Users
          </p>
        </div>
      </motion.div>

      {/* SMALL FLOATING ICON */}
      <div className="absolute top-[44%] right-10 w-14 h-14 rounded-2xl bg-white shadow-lg flex items-center justify-center text-[#2b57b5] z-20">
        <FaChartLine size={22} />
      </div>
    </motion.div>
  );
};

export default WealthGraphic;

